var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('doughnut-chart',{attrs:{"data":_vm.data,"labels":_vm.getLabels,"options":{
    cutout: 120,
    plugins: { legend: { display: false }, datalabels: { display: false } },
    responsive: true,
  },"count-formatter":function (value) { return _vm.$formatCurrency(value); }}},[(!_vm.hideTotal)?_vm._t("default",function(){return [_vm._v(_vm._s(_vm.$formatCurrency(_vm.total)))]}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }